import { render, staticRenderFns } from "./service.vue?vue&type=template&id=43bc463e&scoped=true"
import script from "./service.vue?vue&type=script&lang=js"
export * from "./service.vue?vue&type=script&lang=js"
import style0 from "./service.vue?vue&type=style&index=0&id=43bc463e&prod&lang=scss"
import style1 from "./service.vue?vue&type=style&index=1&id=43bc463e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43bc463e",
  null
  
)

export default component.exports